// extracted by mini-css-extract-plugin
module.exports = {"mentorCard":"MentorCard_mentorCard__ZO0Iu","mentorLink":"MentorCard_mentorLink__D_u3_","mentorAvatar":"MentorCard_mentorAvatar__ckusM"};